export default {
  methods: {

    getPrizeImagePath () {
      return 'https://'+ this.$store.state.company.Id+'/img/' + this.$store.state.company.companyId + '/membership_prizes/'
    },

    getMembershipBannerImagePath () {
      return 'https://'+ this.$store.state.company.Id+'/img/' + this.$store.state.company.companyId + '/membership_banners/'
    }
  }
}